import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizeService } from './authorize.service';
import { map, take } from 'rxjs/operators';
import { ApplicationPaths, QueryParameterNames } from './api-authorization.constants';
import { SessionContextService } from 'src/app/services/session-context.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard  {

  authService: AuthorizeService;
  router: Router;
  session: SessionContextService;

  constructor() {
    this.authService = inject(AuthorizeService);
    this.router = inject(Router);
    this.session  = inject(SessionContextService);
  }
  
  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let x: Observable<boolean> = this.authService.isAuthenticated().pipe(
      take(1),
      map((isAuthenticated) => {
        return this.handleAuthorization(_next, isAuthenticated, state);
      })
    );
    return x;
  }

  private handleAuthorization(route: ActivatedRouteSnapshot, isAuthenticated: boolean, state: RouterStateSnapshot) {
    if (isAuthenticated == false) {
      this.router.navigate(ApplicationPaths.LoginPathComponents, {
        queryParams: {
          [QueryParameterNames.ReturnUrl]: state.url
        }
      });
      return;
    }

    if ("auth" in route.data) {
      var routeData = route.data['auth'];
      if (routeData !== "") {
        if (this.session.ctx.EmployeeId > 0)
          return this.authService.hasPriv(routeData);
        else
          return false;
      }
    }
    return true;
  }
}
